import React, { FC, PropsWithChildren } from 'react';

export const PAGE_CID = 'Page';

const Page: FC<PropsWithChildren> = ({ children }) => <div className={PAGE_CID}>{children}</div>;

export default Page;
